<div class="cart-product-suggestion">
  <div class="cart-product-suggestion__info">
    <div class="cart-product-suggestion__icon">
      <umkt-icon [icon]="icon" size="sm"></umkt-icon>
    </div>

    <div class="cart-product-suggestion__content">
      <span class="cart-product-suggestion__title">{{ suggestion.titleKey | i18n }}</span>

      <div class="cart-product-suggestion__meta">
        <span class="cart-product-suggestion__badge">
          {{ 'components.cartProductSuggestion.recommended' | i18n }}
        </span>
      </div>

      <p *ngIf="suggestion.descriptionKey" class="cart-product-suggestion__description">
        {{ suggestion.descriptionKey | i18n }}
      </p>
    </div>
  </div>

  <div class="cart-product-suggestion__aside">
    <span *ngIf="suggestion.price !== null" class="cart-product-suggestion__price">
      {{ suggestion.price | currencyBRL }}
    </span>

    <div class="cart-product-suggestion__actions">
      <button
        type="button"
        class="cart-product-suggestion__btn cart-product-suggestion__btn--primary"
        [disabled]="loading"
        (click)="onAccept()"
      >
        {{ suggestion.primaryActionKey | i18n }}
      </button>
      <button
        type="button"
        class="cart-product-suggestion__btn cart-product-suggestion__btn--ghost"
        [disabled]="loading"
        (click)="onDismiss()"
      >
        {{ suggestion.dismissActionKey | i18n }}
      </button>
    </div>
  </div>
</div>
